import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ManualRequestCard } from '@/entities/manual-request'

export const Route = createFileRoute(
  '/_auth/applications/manual-requests/manual-request/$requestId/common'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <ManualRequestCard />
      <Outlet />
    </>
  )
}
